import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.scss';
import ScrollToTop from './components/ScollToTop/scrollToTop.component';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import useParentAuth from './hooks/useParentAuth';
import HomeScreen from './pages/home/home.screen';
import NotFoundScreen from './pages/notFound/notFound.screen';
import UnauthorizedScreen from './pages/unauthorized/unauthorized.screen';
import ModulesScreen from './pages/modules/modules.screen';
import SearchScreen from './pages/search/search.screen';
import ModuleScreen from './pages/modules/module.screen';
import ModuleDetailScreen from './pages/modules/moduleDetail.screen';
import ModuleDownloadsScreen from './pages/modules/moduleDownloads.screen';
import TypeScreen from './pages/type/type.screen';
import PrivacyScreen from './pages/privacy/privacy.screen';
import TermsScreen from './pages/privacy/terms.screen';
import BlogScreen from './pages/blog/blog.screen';
// import LoginScreen from './pages/Auth/Login/login.screen';

function App() {
  // Escuchar mensajes del sistema padre globalmente
  useParentAuth();

  return (
    <main className="app-main">
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            {/* Rutas públicas (no requieren autenticación) */}
            <Route path="/aviso-de-privacidad" element={<PrivacyScreen />} />
            <Route path="/terminos-y-condiciones" element={<TermsScreen />} />
            <Route path="/no-autorizado" element={<UnauthorizedScreen />} />

            {/* Rutas protegidas (requieren autenticación) */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomeScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/modulos-sitic"
              element={
                <ProtectedRoute>
                  <ModulesScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:collection"
              element={
                <ProtectedRoute>
                  <ModuleScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:collection/:module"
              element={
                <ProtectedRoute>
                  <ModuleDetailScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:collection/:download/:module"
              element={
                <ProtectedRoute>
                  <ModuleDownloadsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contenidos/:collection"
              element={
                <ProtectedRoute>
                  <TypeScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resultado-de-busqueda"
              element={
                <ProtectedRoute>
                  <SearchScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog"
              element={
                <ProtectedRoute>
                  <BlogScreen />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/inicio-de-sesion" element={<LoginScreen />} /> */}
            <Route path="*" element={<NotFoundScreen />} /> {/* Ruta 404 */}
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </main>
  );
}

export default App;
